import {
  MediaExpandedList,
  MediaGrid,
  SermonExpandedListItemSkeleton,
  SermonGridItemSkeleton,
  SermonListItemSkeleton,
} from '@nucleus/sermon-theme-elements';
import React from 'react';
import styled from 'styled-components';

type SermonBlockSkeletonLayout = 'expanded' | 'list' | 'filmstrip' | 'grid';

interface SermonBlockSkeletonProps {
  layout?: SermonBlockSkeletonLayout;
  count?: number;
}

export const SermonBlockSkeleton = ({ layout, count = 6 }: SermonBlockSkeletonProps): JSX.Element => {
  const items = Array.from({ length: count }, (_, index) => index);

  switch (layout) {
    case 'expanded':
      return (
        <MediaExpandedList>
          {items.slice(0, 3).map((index) => (
            <SermonExpandedListItemSkeleton key={index} />
          ))}
        </MediaExpandedList>
      );
    case 'list':
      return (
        <ListSkeletonContainer>
          {items.map((index) => (
            <SermonListItemSkeleton key={index} />
          ))}
        </ListSkeletonContainer>
      );
    case 'filmstrip':
      return (
        <FilmstripSkeletonContainer>
          {items.map((index) => (
            <SermonGridItemSkeleton key={index} />
          ))}
        </FilmstripSkeletonContainer>
      );
    case 'grid':
    default:
      return (
        <GridSkeletonContainer>
          {items.map((index) => (
            <SermonGridItemSkeleton key={index} />
          ))}
        </GridSkeletonContainer>
      );
  }
};

export const SermonCollectionBlockSkeleton = (): JSX.Element => {
  return (
    <GridSkeletonContainer>
      {Array.from({ length: 4 }, (_, index) => (
        <SermonGridItemSkeleton key={index} />
      ))}
    </GridSkeletonContainer>
  );
};

const GridSkeletonContainer = styled(MediaGrid)`
  margin-bottom: 36px;
`;

const ListSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const FilmstripSkeletonContainer = styled.div`
  display: flex;
  gap: 12px;
  overflow: hidden;
  padding-block: 36px;
  margin-block: -36px;

  > * {
    flex: 0 0 min(100%, max(calc(33% - 6px), 300px));
  }
`;
